import React, { memo, ReactElement, useCallback, useContext, useMemo } from 'react';
import { IJobMeta } from '../../utils/BackgroundJobs';
import EmailPrintPreviewForm from '../../views/company/EmailPrintPreviewForm';

import { FilterOperation, IFilterInput } from '../../graphql/schema/p4types';
import AppContext from '../Context/AppContext';
import { useToastController } from '@fluentui/react-components';
import FluentModal from './FluentModal';

const EmailPrintPreviewModal = memo(({ modalOpen, job }: { modalOpen: boolean; job?: IJobMeta }) => {
  const previewFilters = useMemo<Array<IFilterInput>>(() => {
    return job
      ? [
          {
            filterOperation: FilterOperation.Equals,
            filterParameters: {
              field: 'jobId',
              value: job.jobId,
            },
          },
        ]
      : [];
  }, [job]);

  return (
    <FluentModal
      isOpen={modalOpen}
      styles={{
        main: { minWidth: '1000px', width: '90vw', minHeight: '500px' },
        scrollableContent: { height: '80vh' },
      }}
    >
      <EmailPrintPreviewForm predefinedFilters={previewFilters} embeddedView={true} />
    </FluentModal>
  );
});

export const useOnProcessPreview = (): [(job: IJobMeta) => void, ReactElement] => {
  const { toasterId } = useContext(AppContext);
  const { dispatchToast } = useToastController(toasterId);

  return useCallback(
    (job: IJobMeta) => {
      if (job?.properties?.['E-Mail with Preview'] === 'TRUE') {
        dispatchToast(<EmailPrintPreviewModal modalOpen={true} job={job} />, { intent: 'info', timeout: -1 });
      }
    },
    [dispatchToast]
  );
};
